import { RouteRecordRaw } from "vue-router";
import { PATH } from "@/core/constants/path";
import { ROLES_AND_PERMISSION_ON_ROUTES } from "@/core/configs/rolesAndPermissionsMappingOnRoutes";

const routes: Array<RouteRecordRaw> = [
  {
    path: PATH.GROUPS,
    name: "Groups",
    meta: {
      roles: ROLES_AND_PERMISSION_ON_ROUTES.GROUPS.ROLES,
      permissions: ROLES_AND_PERMISSION_ON_ROUTES.GROUPS.PERMISSIONS,
    },
    component: () => import("@/modules/Groups/views/GroupsList.vue"),
  },
  {
    path: PATH.GROUP_BOOKING_DETAILS,
    name: "GroupBookingDetails",
    meta: {
      roles: ROLES_AND_PERMISSION_ON_ROUTES.GROUPS.ROLES,
      permissions: ROLES_AND_PERMISSION_ON_ROUTES.GROUPS.PERMISSIONS,
    },
    component: () => import("@/modules/Groups/views/GroupBookingDetails.vue"),
  },
];

export default routes;
